import * as api from "@/api/rbi";
import { Datasheet } from "@/api/datasheets";
import { Page } from "@/util";
import { useContext } from "react";
import { useMutation, useQuery } from "react-query";
import { WelderContext } from "./reducer";
import { WelderRow, WelderWeld } from "@/api/rbi";
import { WeldListFilters } from "./types";

export function useGetWeldList(filters: WeldListFilters, datasheet?: Datasheet) {
  const datasheetId = datasheet?.datasheetId ?? "";
  return useQuery({
    enabled: Boolean(datasheet),
    queryKey: ["rbi/welder/welds", { datasheetId, filters }],
    queryFn: () => api.getWelderWelds(datasheetId, filters),
  });
}

export function useGetProcesses(welds: WelderWeld[]) {
  const { updateState } = useContext(WelderContext);
  const weldIds = welds.map((x) => x.weldId);

  return useQuery({
    refetchOnWindowFocus: false,
    queryKey: ["rbi/welder/processes", { weldIds }],
    queryFn: () => api.getWelderRows(weldIds),
    onSuccess: (data) => {
      updateState({ type: "Processes", payload: data });
    },
  });
}

export function useSave() {
  return useMutation((processes: WelderRow[]) => api.saveWelderRows(processes), {
    onSuccess: () => {
      Page.redirect("rbi/welder");
    },
  });
}
